import routerOptions from './router.options';

import coreRoutes from './_core.routes';

import homeRoutes from './home.routes';
// import InsertCodeRequestRoutes from './insert-code-request.routes';
import RegisterRoutes from './register.routes';
import AcceptedRequestRoutes from './accepted-request.routes';
import PendingRequestRoutes from './pending-request.routes';
import DetailRequestRoutes from './detail-request.routes';
import EditRegisterContactRoutes from './edit-data-contact.routes';

import LoginOkRoutes from './login-ok.routes';
import NotFoundRoutes from './not-found.routes';

import afterEach from './hooks/after-each.hooks';
import beforeEach from './hooks/before-each.hooks';
import beforeResolve from './hooks/before-resolve.hooks';

const routes = [
  ...homeRoutes,
  // ...InsertCodeRequestRoutes,
  ...RegisterRoutes,
  ...AcceptedRequestRoutes,
  ...PendingRequestRoutes,
  ...DetailRequestRoutes,
  ...EditRegisterContactRoutes,

  ...LoginOkRoutes,
  ...coreRoutes, // (!) Always last

  ...NotFoundRoutes,
];

const hooks = {
  afterEach,
  beforeEach,
  beforeResolve,
};

export {
  hooks,
  routerOptions,
  routes,
};
